<template>
  <section>
    <!-- Componentes externos -->
    <VerReportePorUnidadGestion />
    <v-card>
      <v-card-text class="grey lighten-2 text--info py-0">
        <v-layout align-center justify-space-between row wrap>
          <v-flex shrink>
            <h3 class="primary--text">
              <v-icon color="primary">home</v-icon> Listado de dependencias
            </h3>
          </v-flex>
          <v-flex shrink
            ><h3 class="primary--text">
              Gestión: {{ this.$route.params.gestion }}
            </h3>
          </v-flex>
          <v-flex xs12 class="px-3 py-0">
            <v-btn icon color="primary" to="/vacaciones-gestion-RRHH">
              <v-icon>arrow_back</v-icon>
            </v-btn>
            <strong> LISTADO DE GESTIONES</strong>
          </v-flex>
        </v-layout>
      </v-card-text>
      <v-card-text>
        <crud-table
          class="tabla-comprimida-light"
          :headers="headers"
          :url="url"
          :filters="filters"
          :data-graphql="dataGraphql"
          :graphql="graphql"
          :initData="initData"
        >
          <!-- Template de filas y columnas -->
          <template slot="items" slot-scope="items">
            <!-- Agregar las columnas que consideré necesarias -->

            <td class="text-xs-center">
              {{ items.item.nombre_unidad }}
            </td>
            <td class="nowrap text-xs-center">
              <v-btn
                color="info"
                :to="
                  `/listado-funcionarios-RRHH-vacaciones/${$util.encodeString(
                    $route.params.gestion
                  )}/${$util.encodeString(
                    items.item.nro_item
                  )}/${$util.encodeString(
                    items.item.id_unidad
                  )}/${$util.encodeString(
                    items.item.case
                  )}/${$util.encodeString(items.item.id_persona)}`
                "
                icon
                title="Ver programaciones de vacación"
              >
                <v-icon>remove_red_eye</v-icon>
              </v-btn>
              <!--  Aprobar programacion de LA VACACION-->
              <!-- <v-btn 
                  color="#44deaa"
                  @click="aprobarProgramacionDependenciaRRHH(items.item)"
                  icon
                  title="Aprobar programación de vacación"
                >
                  <v-icon>done</v-icon>
              </v-btn> -->
              <v-btn
                color="warning"
                @click="verReportePorUnidadGestion(items.item, 1)"
                icon
                dark
                title="Ver reporte de vacación"
              >
                <v-icon>picture_as_pdf</v-icon>
              </v-btn>
              <v-btn
                dark
                color="#44deaa"
                @click="aprobarProgramacionDependenciaRRHH(items.item)"
                icon
                title="Aprobar programación de vacación de la dependencia"
              >
                <v-icon>done</v-icon>
              </v-btn>
            </td>
          </template>
        </crud-table>
      </v-card-text>
    </v-card>
  </section>
</template>

<script>
import CrudTable from "@/common/util/crud-table/CrudTable.vue"; // Componente Tabla Dinámica
import crud from "@/common/util/crud-table/mixins/crud-table"; // Funciones y Metodos
import VerReportePorUnidadGestion from "../vacaciones/dialogs/VerReportePorUnidadGestion.vue";

export default {
  // Importación de métodos y funciones de un archivo mixin
  mixins: [crud],
  // Variables iniciales del componente
  data() {
    let user = this.$storage.get("user");
    let id_persona = user.id_persona;

    return {
      url: "vUnidadesConAutoridadess",
      graphql: true,
      id_estado_programacion: null,
      // Cabecera de la tabla
      initData: [],
      headers: [
        {
          text: "Dependencia",
          value: "nombre_unidad"
        },

        { text: this.$t("common.actions"), sortable: false, align: "center" }
      ],
      // Campos solicitados de Graphql(Agregar los que necesite)
      dataGraphql: `
      id_usuario
      id_persona
      id_item
      nro_item
      id_unidad
 	  nombre_unidad
      case
      `,
      // Filtros del componente CrudTable ejemplo:
      // {
      // 	field: 'Campo definido en Graphql',
      // 	label: 'Etiqueta del input generado',
      // 	type: 'text', // Tipo de input en el filtro
      // 	typeG: 'String' // Tipo definido en Graphql
      // }
      filters: [
        {
          field: "nombre_unidad",
          label: "Dependencia",
          type: "text", // Tipo de input en el filtro
          typeG: "String" // Tipo definido en Graphql
        }
      ],
      estado_vacacion: [],
      nombre: null,
      fecha_ingreso: null,
      id_estado_programacion: null,
      nro_item: null,
      persona: null
    };
  },
  // Funcionalidades que se ejecutan al montar el componente
  async mounted() {
    // Verificando si el usuario tiene permiso para interactual con el componente

    this.onFilter();
    const rolesPermitidos = [0]; // ID's de roles permitidos
    if (!this.$util.permisoRol(rolesPermitidos)) {
      this.$router.push("/403");
    }
    this.id_estado_programacion = await this.$service.obtenerEstadoProgramación(
      parseInt(this.$route.params.gestion)
    );

    this.$bus.$on("closeDialogVerReportePorUniGestion", () => {});
  },
  // Métodos y funciones del componente
  methods: {
    async verReportePorUnidadGestion(item, valor) {
      item.id_estado = this.id_estado_programacion;
      if (
        item.nombre_unidad.includes("DIRECCI") ||
        item.nombre_unidad.includes("VICEMINISTERIO") ||
        item.nombre_unidad.includes("GABINETE") ||
        item.nombre_unidad.includes("GABINETE") ||
        item.nombre_unidad.includes("DESPACHO")
      ) {
        item.valor = 4;
      } else {
        item.valor = 3;
      }
      this.$bus.$emit("openDialogVerReportePorUnidadGestion", item);
    },

    async aprobarProgramacionDependenciaRRHH(item) {
      try {
        this.$confirm(
          "¿Esta seguro(a) que desea aprobar la  programación de toda la dependencia?",
          async () => {
            let user = this.$storage.get("user");
            let res = await this.$service.graphql({
              query: `
              query{
                runQuery(consulta: "SELECT vacaciones.fn_aprueba_vacacion_programada_por_unidad_rrhh(${parseInt(
                  item.id_unidad
                )},${parseInt(this.$route.params.gestion)},${item.id_persona},${
                user.id
              })"){
                  respuesta
                }
              }
            `
            });
            res =
              res.runQuery.respuesta[0]
                .fn_aprueba_vacacion_programada_por_unidad_rrhh;
            let rpta = res.split("|");

            if (rpta[0] == "1") {
              this.$confirm(
                "La programación de la dependencia fué aprobada",
                async () => {}
              );
            } else {
              this.$confirm(resps[1], async () => {});
            }
          }
        );
      } catch (error) {
        console.log(error);
      }
    }
  },

  // Definición de componentes importados
  components: {
    CrudTable,
    VerReportePorUnidadGestion
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/admin/vacacion_rrhh/VacacionesListadoUnidades.vue